"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenItem = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const Colors_1 = require("../../../Colors");
const common_1 = require("../../../common");
exports.OpenItem = react_1.default.memo(({ headItem, item, isTeacher, isMobile, isTablet, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const renderFile = react_1.default.useMemo(() => item.files && item.files.length > 0 ? (react_1.default.createElement("div", { className: "file file-value", style: { justifyContent: 'unset' } },
        react_1.default.createElement(common_1.Icon, { icon: "file", size: isMobile ? 12 : isTablet ? 14 : 20, fill: Colors_1.Colors.w_grey }),
        react_1.default.createElement("p", { className: "overText2" },
            "(",
            item.files.length,
            ")"))) : undefined, [item.files, isTablet]);
    const renderDate = react_1.default.useMemo(() => (react_1.default.createElement("p", { className: "overText2 date" }, (0, moment_1.default)(item.creation_time).format('YYYY-MM-DD'))), [item.creation_time, headItem]);
    switch (headItem.title) {
        case 'importantAndtitleAndFiles':
            return (react_1.default.createElement("div", { className: "home-title" },
                item.number === -1 && (react_1.default.createElement("p", { className: "must-read", style: { minWidth: 'fit-content' } },
                    "[",
                    t('supportRoom.mustRead'),
                    "]")),
                react_1.default.createElement("p", { className: "overText name" }, item.title),
                renderFile));
        case 'title':
            if (isMobile) {
                return (react_1.default.createElement("div", null,
                    isTeacher && item.importance && (react_1.default.createElement("p", { className: "must-read importance", style: {
                            minWidth: 'fit-content',
                            ...(isTeacher
                                ? { top: '13px', position: 'absolute', left: '30px' }
                                : {}),
                        } }, t('supportRoom.mustRead'))),
                    react_1.default.createElement("p", { className: "overText name" }, item.title)));
            }
            else {
                return react_1.default.createElement("p", { className: "overText2" }, item.title);
            }
        case 'no':
            return (react_1.default.createElement("p", { className: "overText2" }, item.number === -1 ? t('supportRoom.mustRead') : !isMobile && item.number));
        case 'files':
            return renderFile || react_1.default.createElement("p", null, "-");
        case 'creation_time':
            return renderDate;
        case 'fileAndTime':
            return (react_1.default.createElement("div", { className: "notice-info-wrap" },
                renderFile,
                react_1.default.createElement("div", { className: "view-wrap" },
                    react_1.default.createElement(common_1.Icon, { icon: "view", size: 13, fill: Colors_1.Colors.light_grey }),
                    react_1.default.createElement("p", null, item['views'])),
                isTeacher && react_1.default.createElement("p", null, item['author_name']),
                renderDate));
        default:
            return (react_1.default.createElement("p", { className: `
                        ${headItem.title === 'answerState' && item[headItem.title] === '답변완료'
                    ? 'pink'
                    : item[headItem.title] === '답변대기'
                        ? 'purple'
                        : ''} ${headItem.title} overText2
		            ` }, headItem.title === 'creation_time'
                ? (0, moment_1.default)(item.creation_time).format('YYYY-MM-DD')
                : item[headItem.title]));
    }
});
